<template>
  <div>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64" color="primary" />
    </v-overlay>
    <div v-if="!loading">
      <v-container>
        <v-form ref="form">
          <v-row>
            <h2 class="pb-5">{{ this.pageTitle }} ({{ this.dataItemsLength }})</h2>
          </v-row>
  
          <v-container
            id="scroll-target"
            class="custom-form overflow-y-auto px-5"
          >
            <v-card>
              <v-expansion-panels v-model="panel" multiple>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <v-subheader class="blue--text"
                      >({{this.dataItemsDueconfirm.length}}) {{$t('reporalertlisting.dueforconfirmationdate')}}</v-subheader
                    >
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12" sm="16">
                        <v-data-table
                          :headers="dataHeaderDueConfirm"
                          :items="this.dataItemsDueconfirm"
                          hide-default-footer
                          item-key="id"
                        >
                          <template v-slot:body>
                            <tbody>
                              <tr
                                v-for="item in dataItemsDueconfirm"
                                :key="item.id"
                              >
                                <td>{{ item.duedays }}</td>
                                <td>{{ item.dueconfirmdate }}</td>
                                <td>{{ item.staffcode }}</td>
                                <td>{{ item.psnname }}</td>
                                <td>{{ item.hiredate }}</td>
                                <td>{{ item.compnycode }}</td>
                               
                              </tr>
                            </tbody>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
  
                 
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <v-subheader class="blue--text"
                      >({{this.dataItemsExtendedDueconfirm.length}}) {{$t('reporalertlisting.dueextendedconfirmationdate')}}</v-subheader
                    >
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12" sm="16">
                        <v-data-table
                          :headers="dataHeaderExtendedDueConfirm"
                          :items="this.dataItemsExtendedDueconfirm"
                          hide-default-footer
                          item-key="id"
                        >
                          <template v-slot:body>
                            <tbody>
                              <tr
                                v-for="item in dataItemsExtendedDueconfirm"
                                :key="item.id"
                              >
                                <td>{{ item.duedays }}</td>
                                <td>{{ item.exdueconfirmdate }}</td>
                                <td>{{ item.staffcode }}</td>
                                <td>{{ item.psnname }}</td>
                                <td>{{ item.hiredate }}</td>
                                <td>{{ item.compnycode }}</td>
                                
                              </tr>
                            </tbody>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                
  
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <v-subheader class="blue--text"
                      >({{this.dataItemsDuecessation.length}}) {{$t('reporalertlisting.dueforcessationdate')}}</v-subheader
                    >
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12" sm="16">
                        <v-data-table
                          :headers="dataHeaderDueCessation"
                          :items="this.dataItemsDuecessation"
                          hide-default-footer
                          item-key="id"
                        >
                          <template v-slot:body>
                            <tbody>
                              <tr
                                v-for="item in dataItemsDuecessation"
                                :key="item.id"
                              >
                                <td>{{ item.cessadays }}</td>
                                <td>{{ item.cessadate }}</td>
                                <td>{{ item.staffcode }}</td>
                                <td>{{ item.psnname }}</td>
                                <td>{{ item.hiredate }}</td>
                                <td>{{ item.compnycode }}</td>
                                <td>{{ item.lworkdate }}</td>
                                <td>{{ item.olastdate }}</td>
                              </tr>
                            </tbody>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
  
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <v-subheader class="blue--text"
                      >({{this.dataItemsDuecontract.length}}) {{$t('reporalertlisting.dueforcontractexpiry')}}</v-subheader
                    >
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12" sm="16">
                        <v-data-table
                          :headers="dataHeaderDueContract"
                          :items="this.dataItemsDuecontract"
                          hide-default-footer
                          item-key="id"
                        >
                          <template v-slot:body>
                            <tbody>
                              <tr
                                v-for="item in dataItemsDuecontract"
                                :key="item.id"
                              >
                                <td>{{ item.contractdays }}</td>
                                <td>{{ item.contrenddate }}</td>
                                <td>{{ item.staffcode }}</td>
                                <td>{{ item.psnname }}</td>
                                <td>{{ item.hiredate }}</td>
                                <td>{{ item.compnycode }}</td>
                                <td>{{ item.deptcode }}</td>
                                <td>{{ item.brchcode }}</td>
                                <td>{{ item.contrprd }}</td>
                              </tr>
                            </tbody>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
  
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <v-subheader class="blue--text"
                      >({{this.dataItemsDuedocument.length}}) {{$t('reporalertlisting.duefordocexpiry')}}</v-subheader
                    >
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12" sm="16">
                        <v-data-table
                          :headers="dataHeaderDueDocument"
                          :items="this.dataItemsDuedocument"
                          hide-default-footer
                          item-key="id"
                        >
                          <template v-slot:body>
                            <tbody>
                              <tr
                                v-for="item in dataItemsDuedocument"
                                :key="item.id"
                              >
                                <td>{{ item.documentdays }}</td>
                                <td>{{ item.staffcode }}</td>
                                <td>{{ item.doctypecode }}</td>
                                <td>{{ item.docno }}</td>
                                <td>{{ item.startdate }}</td>
                                <td>{{ item.enddate }}</td>
                                <td>{{ item.psnname }}</td>
                                <td>{{ item.compnycode }}</td>
                                <td>{{ item.deptcode }}</td>
                                <td>{{ item.brchcode }}</td>
                              </tr>
                            </tbody>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
  
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <v-subheader class="blue--text"
                    >({{this.dataItemsDuebirthday.length}}) {{$t('reporalertlisting.duefordob')}}</v-subheader>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12" sm="16">
                        <v-data-table
                          :headers="dataHeaderDueBirthday"
                          :items="this.dataItemsDuebirthday"
                          hide-default-footer
                          item-key="id"
                        >
                          <template v-slot:body>
                            <tbody>
                              <tr
                                v-for="item in dataItemsDuebirthday"
                                :key="item.id"
                              >
                                <td>{{ item.birthdaydays }}</td>
                                <td>{{ item.staffcode }}</td>
                                <td>{{ item.dob }}</td>
                                <td>{{ item.psnname }}</td>
                                <td>{{ item.age }}</td>
                                <td>{{ item.gendername }}</td>
                                <td>{{ item.compnycode }}</td>
                                <td>{{ item.deptcode }}</td>
                                <td>{{ item.brchcode }}</td>
                              </tr>
                            </tbody>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
  
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <v-subheader class="blue--text"
                      >({{this.dataItemsDuework3years.length}}) {{$t('reporalertlisting.dueforwanthree')}}</v-subheader
                    >
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12" sm="16">
                        <v-data-table
                          :headers="dataHeaderDueWork3years"
                          :items="this.dataItemsDuework3years"
                          hide-default-footer
                          item-key="id"
                        >
                          <template v-slot:body>
                            <tbody>
                              <tr
                                v-for="item in dataItemsDuework3years"
                                :key="item.id"
                              >
                                <td>{{ item.duedays }}</td>
                                <td>{{ item.servicedate }}</td>
                                <td>{{ item.staffcode }}</td>
                                <td>{{ item.psnname }}</td>
                                <td>{{ item.hiredate }}</td>
                                <td>{{ item.compnycode }}</td>
                                <td>{{ item.deptcode }}</td>
                                <td>{{ item.brchcode }}</td>
                                <td>{{ item.positionid }}</td>
                              </tr>
                            </tbody>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
  
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <v-subheader class="blue--text"
                      >({{this.dataItemsDuework5years.length}}) {{$t('reporalertlisting.dueforwanfive')}}</v-subheader
                    >
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12" sm="16">
                        <v-data-table
                          :headers="dataHeaderDueWork5years"
                          :items="this.dataItemsDuework5years"
                          hide-default-footer
                          item-key="id"
                        >
                          <template v-slot:body>
                            <tbody>
                              <tr
                                v-for="item in dataItemsDuework5years"
                                :key="item.id"
                              >
                                <!-- <td>{{ item.work5yearsdays }}</td> -->
                                <td>{{ item.duedays }}</td>
                                <td>{{ item.servicedate }}</td>
                                <td>{{ item.staffcode }}</td>
                                <td>{{ item.psnname }}</td>
                                <td>{{ item.hiredate }}</td>
                                <td>{{ item.compnycode }}</td>
                                <td>{{ item.deptcode }}</td>
                                <td>{{ item.brchcode }}</td>
                                <td>{{ item.positionid }}</td>
                              </tr>
                            </tbody>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
  
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <v-subheader class="blue--text"
                      >({{this.dataItemsDuework10years.length}}) {{$t('reporalertlisting.dueforwanten')}}</v-subheader
                    >
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12" sm="16">
                        <v-data-table
                          :headers="dataHeaderDueWork10years"
                          :items="this.dataItemsDuework10years"
                          hide-default-footer
                          item-key="id"
                        >
                          <template v-slot:body>
                            <tbody>
                              <tr
                                v-for="item in dataItemsDuework10years"
                                :key="item.id"
                              >
                                <td>{{ item.duedays }}</td>
                                <td>{{ item.servicedate }}</td>
                                <td>{{ item.staffcode }}</td>
                                <td>{{ item.psnname }}</td>
                                <td>{{ item.hiredate }}</td>
                                <td>{{ item.compnycode }}</td>
                                <td>{{ item.deptcode }}</td>
                                <td>{{ item.brchcode }}</td>
                                <td>{{ item.positionid }}</td>
                              </tr>
                            </tbody>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card>
          </v-container>
        </v-form>
      </v-container>
      <div v-if="isErr">
        <app-error
          v-bind:parentError="{
            data: this.errMsg,
            isErr: this.isErr,
          }"
          v-on:closeError="isErr = $event"
        />
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";

export default {
  data() {
    return {
      pageTitle: this.$t('setupalert.alertlist'),

      dataHeaderDueConfirm: [
        { text: this.$t('reporalertlisting.dueindays'), value: "duedays", width: "150px" },
        { text: this.$t('reporalertlisting.dueforconfirmationdate'), value: "dueconfirmdate", width: "200px"},
        { text: this.$t('columns.staffid'), value: "staffcode", width: "120px" },
        { text: this.$t('columns.name'), value: "psnname", width: "200px" },
        { text: this.$t('recstaffdetails.hiredate'), value: "hiredate", width: "150px" },
        { text: this.$t('columns.company'), value: "compnycode", width: "150px" },
        // {
        //   text: "Extended Confirmation Date",
        //   value: "exdueconfirmdate",
        //   width: "220px",
        // },
      ],

      dataHeaderExtendedDueConfirm: [
        { text: this.$t('reporalertlisting.dueindays'), value: "duedays", width: "150px" },
        { text: this.$t('reporalertlisting.extendedconfirmationdate'), value: "exdueconfirmdate", width: "220px"},
        { text: this.$t('columns.staffid'), value: "staffcode", width: "120px" },
        { text: this.$t('columns.name'), value: "psnname", width: "200px" },
        { text: this.$t('recstaffdetails.hiredate'), value: "hiredate", width: "150px" },
        { text: this.$t('columns.company'), value: "compnycode", width: "150px" },
       
      ],

      dataHeaderDueCessation: [
        { text: this.$t('reporalertlisting.dueindays'), value: "cessadays", width: "120px" },
        { text: this.$t('reporalertlisting.dueforcessationdate'), value: "cessadate", width: "190px" },
        { text: this.$t('columns.staffid'), value: "staffcode", width: "120px" },
        { text: this.$t('columns.name'), value: "psnname", width: "150px" },
        { text: this.$t('recstaffdetails.hiredate'), value: "hiredate", width: "150px" },
        { text: this.$t('columns.company'), value: "compnycode", width: "120px" },
        { text: this.$t('reporalertlisting.lastworkingdate'), value: "lworkdate", width: "180px" },
        { text: this.$t('reporalertlisting.officallastdate'), value: "olastdate", width: "180px" },
      ],

      dataHeaderDueContract: [
        { text: this.$t('reporalertlisting.dueindays'), value: "contractdays", width: "120px" },
        { text: this.$t('reporalertlisting.contractexpirydate'), value: "contrenddate", width: "190px" },
        { text: this.$t('columns.staffid'), value: "staffcode", width: "120px" },
        { text: this.$t('columns.name'), value: "psnname", width: "150px" },
        { text: this.$t('recstaffdetails.hiredate'), value: "hiredate", width: "120px" },
        { text: this.$t('columns.company'), value: "compnycode", width: "120px" },
        { text: this.$t('columns.department'), value: "deptcode", width: "150px" },
        { text: this.$t('columns.branch'), value: "brchcode", width: "150px" },
        { text: this.$t('reporalertlisting.contractduration'), value: "contrprd", width: "160px" },
      ],

      dataHeaderDueDocument: [
        { text: this.$t('reporalertlisting.dueindays'), value: "documentdays", width: "120px" },
        { text: this.$t('columns.staffid'), value: "staffcode", width: "120px" },
        { text: this.$t('reporalertlisting.doctype'), value: "doctypecode", width: "150px" },
        { text: this.$t('reporalertlisting.docno'), value: "docno", width: "150px" },
        { text: this.$t('reporalertlisting.docstartdate'), value: "startdate", width: "180px" },
        { text: this.$t('reporalertlisting.docenddate'), value: "enddate", width: "180px" },
        { text: this.$t('columns.name'), value: "psnname", width: "150px" },
        { text: this.$t('columns.company'), value: "compnycode", width: "120px" },
        { text: this.$t('columns.department'), value: "deptcode", width: "120px" },
        { text: this.$t('columns.branch'), value: "brchcode", width: "120px" },
      ],

      dataHeaderDueBirthday: [
        { text: this.$t('reporalertlisting.dueindays'), value: "birthdaydays", width: "120px" },
        { text: this.$t('columns.staffid'), value: "staffcode", width: "120px" },
        { text: this.$t('columns.dob'), value: "dob", width: "140px" },
        { text: this.$t('columns.name'), value: "psnname", width: "150px" },
        { text: this.$t('reporalertlisting.age'), value: "age", width: "100px" },
        { text: this.$t('columns.gender'), value: "gendername", width: "100px" },
        { text: this.$t('columns.company'), value: "compnycode", width: "120px" },
        { text: this.$t('columns.department'), value: "deptcode", width: "120px" },
        { text: this.$t('columns.branch'), value: "brchcode", width: "120px" },
      ],

      dataHeaderDueWork3years: [
        { text: this.$t('reporalertlisting.dueindays'), value: "work3yearsdays", width: "120px" },
        { text: this.$t('reporalertlisting.servicedate'), value: "servicedate", width: "150px" },
        { text: this.$t('columns.staffid'), value: "staffcode", width: "100px" },
        { text: this.$t('columns.name'), value: "psnname", width: "150px" },
        { text: this.$t('recstaffdetails.hiredate'), value: "hiredate", width: "150px" },
        { text: this.$t('columns.company'), value: "compnycode", width: "120px" },
        { text: this.$t('columns.department'), value: "deptcode", width: "120px" },
        { text: this.$t('columns.branch'), value: "brchcode", width: "100px" },
        { text: this.$t('columns.position'), value: "positionid", width: "120px" },
      ],

      dataHeaderDueWork5years: [
        { text: this.$t('reporalertlisting.dueindays'), value: "work5yearsdays", width: "120px" },
        { text: this.$t('reporalertlisting.servicedate'), value: "servicedate", width: "150px" },
        { text: this.$t('columns.staffid'), value: "staffcode", width: "100px" },
        { text: this.$t('columns.name'), value: "psnname", width: "150px" },
        { text: this.$t('recstaffdetails.hiredate'), value: "hiredate", width: "150px" },
        { text: this.$t('columns.company'), value: "compnycode", width: "120px" },
        { text: this.$t('columns.department'), value: "deptcode", width: "120px" },
        { text: this.$t('columns.branch'), value: "brchcode", width: "100px" },
        { text: this.$t('columns.position'), value: "positioncode", width: "120px" },
      ],

      dataHeaderDueWork10years: [
        { text: this.$t('reporalertlisting.dueindays'), value: "work10yearsdays", width: "120px" },
        { text: this.$t('reporalertlisting.servicedate'), value: "servicedate", width: "150px" },
        { text: this.$t('columns.staffid'), value: "staffcode", width: "100px" },
        { text: this.$t('columns.name'), value: "psnname", width: "150px" },
        { text: this.$t('recstaffdetails.hiredate'), value: "hiredate", width: "150px" },
        { text: this.$t('columns.company'), value: "compnycode", width: "120px" },
        { text: this.$t('columns.department'), value: "deptcode", width: "120px" },
        { text: this.$t('columns.branch'), value: "brchcode", width: "100px" },
        { text: this.$t('columns.position'), value: "positioncode", width: "120px" },
      ],

      panel: [this.$route.params.panel - 1],
      dataItemsDueconfirm: [],
      dataItemsExtendedDueconfirm: [],
      dataItemsDuecessation: [],
      dataItemsDuecontract: [],
      dataItemsDuedocument: [],
      dataItemsDuebirthday: [],
      dataItemsDuework3years: [],
      dataItemsDuework5years: [],
      dataItemsDuework10years: [],
      dataItemsLength: [],
      loading: true,
      errMsg: "",
      isErr: false,
    };
  },

  methods: {
    async getDueconfirmdateHandler() {
      const vm = this;
      try {
        // this.loading = true;
        const res = await this.$store.dispatch('get', {url: `/dueconfirmdate/all/${this.$store.getters.userId}`});
        
        vm.dataItemsDueconfirm = res.data.rec;

        for (let i = 0; i < vm.dataItemsDueconfirm.length; i++) {
          if (vm.dataItemsDueconfirm[i].dueconfirmdate) {
            vm.dataItemsDueconfirm[i].dueconfirmdate = moment(
              vm.dataItemsDueconfirm[i].dueconfirmdate
            ).format("YYYY-MM-DD");
          }

          if (vm.dataItemsDueconfirm[i].hiredate) {
            vm.dataItemsDueconfirm[i].hiredate = moment(
              vm.dataItemsDueconfirm[i].hiredate
            ).format("YYYY-MM-DD");
          }

          // var date1 = moment().format("YYYY-MM-DD");
          // var date2 = moment(vm.dataItemsDueconfirm[i].dueconfirmdate).format(
          //   "YYYY-MM-DD"
          // );
          // vm.dataItemsDueconfirm[i].duedays = moment(date1).diff(
          //   moment(date2),
          //   "days"
          // );
        }

        // this.loading = false;
        await this.getExtendedDueconfirmdateHandler();
      } catch (err) {
        vm.errMsg = err;
        this.loading = false;
      }
    },

    async getExtendedDueconfirmdateHandler() {
      const vm = this;
      try {
        // this.loading = true;
        const res = await this.$store.dispatch('get', {url: `/exdueconfirmdate/all/${this.$store.getters.userId}`});
        
        vm.dataItemsExtendedDueconfirm = res.data.rec;
        console.log("extendedconfirm data:", res.data)
      
        for (let i = 0; i < vm.dataItemsExtendedDueconfirm.length; i++) {
          if (vm.dataItemsExtendedDueconfirm[i].exdueconfirmdate) {
            vm.dataItemsExtendedDueconfirm[i].exdueconfirmdate = moment(
              vm.dataItemsExtendedDueconfirm[i].exdueconfirmdate
            ).format("YYYY-MM-DD");
          }

          if (vm.dataItemsExtendedDueconfirm[i].hiredate) {
            vm.dataItemsExtendedDueconfirm[i].hiredate = moment(
              vm.dataItemsExtendedDueconfirm[i].hiredate
            ).format("YYYY-MM-DD");
          }

          // var date3 = moment().format("YYYY-MM-DD");
          // var date4 = moment(vm.dataItemsExtendedDueconfirm[i].exdueconfirmdate).format(
          //   "YYYY-MM-DD"
          // );
          // vm.dataItemsExtendedDueconfirm[i].duedays = moment(date3).diff(
          //   moment(date4),
          //   "days"
          // );
        }

        // this.loading = false;
        await this.getDuecessationdateHandler();
      } catch (err) {
        vm.errMsg = err;
        this.loading = false;
      }
    },

    async getDuecessationdateHandler() {
      const vm = this;
      try {
        // this.loading = true;
        const res = await this.$store.dispatch('get', {url: `/duecessationdate/all/${this.$store.getters.userId}`});
        
        vm.dataItemsDuecessation = res.data.rec;

        for (let i = 0; i < vm.dataItemsDuecessation.length; i++) {
          if (vm.dataItemsDuecessation[i].cessadate) {
            vm.dataItemsDuecessation[i].cessadate = moment(
              vm.dataItemsDuecessation[i].cessadate
            ).format("YYYY-MM-DD");
          }

          if (vm.dataItemsDuecessation[i].hiredate) {
            vm.dataItemsDuecessation[i].hiredate = moment(
              vm.dataItemsDuecessation[i].hiredate
            ).format("YYYY-MM-DD");
          }

          if (vm.dataItemsDuecessation[i].lworkdate) {
            vm.dataItemsDuecessation[i].lworkdate = moment(
              vm.dataItemsDuecessation[i].lworkdate
            ).format("YYYY-MM-DD");
          }

          if (vm.dataItemsDuecessation[i].olastdate) {
            vm.dataItemsDuecessation[i].olastdate = moment(
              vm.dataItemsDuecessation[i].olastdate
            ).format("YYYY-MM-DD");
          }

          // var date1 = moment().format("YYYY-MM-DD");
          // var date2 = moment(vm.dataItemsDuecessation[i].cessadate).format(
          //   "YYYY-MM-DD"
          // );
          // vm.dataItemsDuecessation[i].cessadays = moment(date1).diff(
          //   moment(date2),
          //   "days"
          // );
        }

        // this.loading = false;
        await this.getDuecontractexpiryHandler();
      } catch (err) {
        vm.errMsg = err;
        this.loading = false;
      }
    },

    async getDuecontractexpiryHandler() {
      const vm = this;
      try {
        // this.loading = true;
        const res = await this.$store.dispatch('get', {url: `/duecontractexpiry/all/${this.$store.getters.userId}`});
        console.log("contract res: ", res.data)
        vm.dataItemsDuecontract = res.data.rec;
        console.log("contract items", vm.dataItemsDuecontract)

        for (let i = 0; i < vm.dataItemsDuecontract.length; i++) {
          if (vm.dataItemsDuecontract[i].contrenddate) {
            vm.dataItemsDuecontract[i].contrenddate = moment(
              vm.dataItemsDuecontract[i].contrenddate
            ).format("YYYY-MM-DD");
          }

          if (vm.dataItemsDuecontract[i].hiredate) {
            vm.dataItemsDuecontract[i].hiredate = moment(
              vm.dataItemsDuecontract[i].hiredate
            ).format("YYYY-MM-DD");
          }

          // var date1 = moment().format("YYYY-MM-DD");
          // var date2 = moment(vm.dataItemsDuecontract[i].contrenddate).format(
          //   "YYYY-MM-DD"
          // );
          // vm.dataItemsDuecontract[i].contractdays = moment(date1).diff(
          //   moment(date2),
          //   "days"
          // );
        }

        // this.loading = false;
        await this.getDuedocumentexpiryHandler();
      } catch (err) {
        vm.errMsg = err;
        this.loading = false;
      }
    },

    async getDuedocumentexpiryHandler() {
      const vm = this;
      try {
        // this.loading = true;
        const res = await this.$store.dispatch('get', {url: `/duedocumentexpiry/all/${this.$store.getters.userId}`});
        
        vm.dataItemsDuedocument = res.data.rec;

        for (let i = 0; i < vm.dataItemsDuedocument.length; i++) {
          if (vm.dataItemsDuedocument[i].startdate) {
            vm.dataItemsDuedocument[i].startdate = moment(
              vm.dataItemsDuedocument[i].startdate
            ).format("YYYY-MM-DD");
          }

          if (vm.dataItemsDuedocument[i].enddate) {
            vm.dataItemsDuedocument[i].enddate = moment(
              vm.dataItemsDuedocument[i].enddate
            ).format("YYYY-MM-DD");
          }

          // var date1 = moment().format("YYYY-MM-DD");
          // var date2 = moment(vm.dataItemsDuedocument[i].enddate).format(
          //   "YYYY-MM-DD"
          // );
          // vm.dataItemsDuedocument[i].documentdays = moment(date1).diff(
          //   moment(date2),
          //   "days"
          // );
        }

        // this.loading = false;
        await this.getDuebirthdayHandler();
      } catch (err) {
        vm.errMsg = err;
        this.loading = false;
      }
    },

    async getDuebirthdayHandler() {
      const vm = this;
      console.log("Show birthday id:", this.$store.getters.userId);
      try {
        // this.loading = true;
        const res = await this.$store.dispatch('get', {url: `/duebirthday/all/${this.$store.getters.userId}`});
        
        vm.dataItemsDuebirthday = res.data.rec;
        console.log("dataItemsDuebirthday", this.dataItemsDuebirthday);
        console.log("Birthday resdata", res.data);
        console.log("Birthday resd", res);

        for (let i = 0; i < vm.dataItemsDuebirthday.length; i++) {
          if (vm.dataItemsDuebirthday[i].dob) {
            vm.dataItemsDuebirthday[i].dob = moment(
              vm.dataItemsDuebirthday[i].dob
            ).format("YYYY-MM-DD");
          }

          var date4 = moment(vm.dataItemsDuebirthday[i].dob).format("YYYY-MM-DD");

          const today = moment();
          const nextBirthday = moment(date4).year(today.year());

          if (today.isAfter(nextBirthday)) {
            nextBirthday.add(1, 'year');
          }

          nextBirthday.add(1, 'day');
          vm.dataItemsDuebirthday[i].birthdaydays = nextBirthday.diff(today, 'days');

          var date3 = moment().format("YYYY-MM-DD");
          vm.dataItemsDuebirthday[i].age = moment(date3).diff(moment(date4), 'years');
        }

        // this.loading = false;
        await this.getDuework3yearsHandler();
      } catch (err) {
        vm.errMsg = err;
        this.loading = false;
      }
    },

    async getDuework3yearsHandler() {
      const vm = this;
      try {
        // this.loading = true;
        const res = await this.$store.dispatch('get', {url: `/duework3years/all/${this.$store.getters.userId}`});
        
        vm.dataItemsDuework3years = res.data.rec;
        console.log("3yeardebug", this.dataItemsDuework5years);

        for (let i = 0; i < vm.dataItemsDuework3years.length; i++) {
          if (vm.dataItemsDuework3years[i].servicedate) {
            vm.dataItemsDuework3years[i].servicedate = moment(
              vm.dataItemsDuework3years[i].servicedate
            ).format("YYYY-MM-DD");
          }

          if (vm.dataItemsDuework3years[i].hiredate) {
            vm.dataItemsDuework3years[i].hiredate = moment(
              vm.dataItemsDuework3years[i].hiredate
            ).format("YYYY-MM-DD");
          }

          // var date1 = moment().format("YYYY-MM-DD");
          // var date2 = moment(vm.dataItemsDuework3years[i].servicedate).format(
          //   "YYYY-MM-DD"
          // );
          // vm.dataItemsDuework3years[i].work3yearsdays = moment(date1).diff(
          //   moment(date2),
          //   "days"
          // );
        }

        // this.loading = false;
        await this.getDuework5yearsHandler();
      } catch (err) {
        vm.errMsg = err;
        this.loading = false;
      }
    },

    async getDuework5yearsHandler() {
      const vm = this;
  
      try {
        // this.loading = true;
        const res = await this.$store.dispatch('get', {url: `/duework5years/all/${this.$store.getters.userId}`});

        vm.dataItemsDuework5years = res.data.rec;
        console.log("5yeardebug", this.dataItemsDuework5years);
        for (let i = 0; i < vm.dataItemsDuework5years.length; i++) {
          if (vm.dataItemsDuework5years[i].servicedate) {
            vm.dataItemsDuework5years[i].servicedate = moment(
              vm.dataItemsDuework5years[i].servicedate
            ).format("YYYY-MM-DD");
          }

          if (vm.dataItemsDuework5years[i].hiredate) {
            vm.dataItemsDuework5years[i].hiredate = moment(
              vm.dataItemsDuework5years[i].hiredate
            ).format("YYYY-MM-DD");
          }

          // var date1 = moment().format("YYYY-MM-DD");
          // var date2 = moment(vm.dataItemsDuework5years[i].servicedate).format(
          //   "YYYY-MM-DD"
          // );
          // vm.dataItemsDuework5years[i].work5yearsdays = moment(date1).diff(
          //   moment(date2),
          //   "days"
          // );

          // vm.dataItemsDuework5years[i].work5yearsdays = vm.dataItemsDuework5years[i].duedays;
        }

        // this.loading = false;
        await this.getDuework10yearsHandler();
      } catch (err) {
        vm.errMsg = err;
        this.loading = false;
      }
    },

    async getDuework10yearsHandler() {
      const vm = this;
      try {
        // this.loading = true;
        const res = await this.$store.dispatch('get', {url: `/duework10years/all/${this.$store.getters.userId}`});
        
        vm.dataItemsDuework10years = res.data.rec;
        console.log("10yeardebug", this.dataItemsDuework5years);

        for (let i = 0; i < vm.dataItemsDuework10years.length; i++) {
          if (vm.dataItemsDuework10years[i].servicedate) {
            vm.dataItemsDuework10years[i].servicedate = moment(
              vm.dataItemsDuework10years[i].servicedate
            ).format("YYYY-MM-DD");
          }

          if (vm.dataItemsDuework10years[i].hiredate) {
            vm.dataItemsDuework10years[i].hiredate = moment(
              vm.dataItemsDuework10years[i].hiredate
            ).format("YYYY-MM-DD");
          }

          // var date1 = moment().format("YYYY-MM-DD");
          // var date2 = moment(vm.dataItemsDuework10years[i].servicedate).format(
          //   "YYYY-MM-DD"
          // );
          // vm.dataItemsDuework10years[i].work10yearsdays = moment(date1).diff(
          //   moment(date2),
          //   "days"
          // );
        }

        await this.getDataitemlengthHandler();
      } catch (err) {
        vm.errMsg = err;
        this.loading = false;
      }
    },
  async getDataitemlengthHandler(){
    const vm = this;

    try{
      const alerts = 
      vm.dataItemsDuebirthday.length +
      vm.dataItemsDuecessation.length +
      vm.dataItemsDueconfirm.length +
      vm.dataItemsDuecontract.length +
      vm.dataItemsDuedocument.length +
      vm.dataItemsDuework10years.length +
      vm.dataItemsDuework5years.length +
      vm.dataItemsDuework3years.length +
      vm.dataItemsExtendedDueconfirm.length
      vm.dataItemsLength = alerts
     
      this.loading = false;
    } catch (err) {
      vm.errMsg = err;
      this.loading = false;
    }
  }
},

  async mounted() {
    await this.getDueconfirmdateHandler();
  },
};
</script>